import { render, staticRenderFns } from "./BannerElections2023.vue?vue&type=template&id=fa575100&"
import script from "./BannerElections2023.vue?vue&type=script&lang=js&"
export * from "./BannerElections2023.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports